<template>
<li class="flex py-6 sm:py-10" v-if="item">
    <div class="flex-shrink-0">
        <img :src="item.media ? item.media.source : ''" alt="Front of men&#039;s Basic Tee in sienna." class="w-24 h-24 rounded-md object-center object-cover sm:w-48 sm:h-48">
    </div>

    <div class="ml-4 flex-1 flex flex-col justify-between sm:ml-6">
        <div class="relative pr-9 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:pr-0">
            <div>
                <div class="flex justify-between">
                    <h3 class="text-sm">
                        <a href="#" class="font-medium text-gray-700 hover:text-gray-800"> {{ item.name }} </a>
                    </h3>
                </div>
                <div class="mt-1 flex text-sm">
                    <p class="text-gray-500">{{ item.description }}</p>

                    <p class="ml-4 pl-4 border-l border-gray-200 text-gray-500">{{ item.size }}</p>
                </div>
                <p class="mt-1 text-sm font-medium text-gray-900">{{ item.line_total.formatted_with_symbol }}</p>
            </div>

            <div class="mt-4 sm:mt-0 sm:pr-9">
                <label for="quantity-0" class="sr-only">Quantity, Basic Tee</label>
                <div class="cart-item__details-qty">
                    <button type="button" @click="() => updateQuantity(item.quantity - 1)">-</button>
                    <p>{{ item.quantity }}</p>
                    <button type="button" @click="() => updateQuantity(item.quantity + 1)">+</button>
                </div>

                <div class="absolute top-0 right-0">
                    <button type="button" class="-m-2 p-2 inline-flex text-gray-400 hover:text-gray-500" @click="removeFromCart">
                        <span class="sr-only">Remove</span>
                        <!-- Heroicon name: solid/x -->
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</li>
</template>

<script>
export default {
    name: 'CartItem',
    props: ['item'],
    methods: {
        /**
         * Update the quantity of the current line item in the cart
         *
         * @param {number} quantity The new quantity for the line item
         */
        updateQuantity(quantity) {
            if (quantity < 1) {
                return this.removeItem();
            }
            this.$emit('update-quantity', this.item.id, quantity);
        },
        /**
         * Remove the current line item from the cart
         */
        removeFromCart() {
            this.$emit('remove-from-cart', this.item.id);
        }
    }
}
</script>
